var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"crm-wrapper"},[(!_vm.$route.meta.ignoreCrmSidebar)?_c('crm-sidebar'):_vm._e(),_c('div',{staticClass:"crm-content"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }